import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { MarkerDisplayComponent } from './marker-display.component';

export const ngxMarkerDisplayModule = angular.module('ngxMarkerDisplayModule', [])
	.directive('ngxMarkerDisplay', downgradeComponent({ component: MarkerDisplayComponent }))
	.name;
